import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import { Routes, Route } from 'react-router-dom';
import {Uvod} from "./pages/Uvod";
import {Services} from "./pages/Services";
import {Tutorial} from "./pages/Tutorial";
import {Autentizace} from "./pages/Autentizace";


function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Uvod />} />
        <Route path="/section/*" element={<Uvod />} />
        <Route path="/autentizace" element={<Autentizace />} />
        <Route path="/autentizace/*" element={<Autentizace />} />
        <Route path="/tutorial" element={<Tutorial />} />
        <Route path="/tutorial/*" element={<Tutorial />} />
        <Route path="/services/:service/*" element={<Services />} />
        <Route path="/services/:service" element={<Services />} />
      </Routes>
    </div>
  );
}

export default App;
